import store from "@/store";

import { verifyStrictPermission } from "@/common/lib/permissions";

const abilityPluginImpl = {};

abilityPluginImpl.install = function abilityPlugin(Vue) {
    Vue.prototype.$ability = {
        hasPermission: function (allowedScope, allowGlobalPermission = false) {
            const hasAccess =
                verifyStrictPermission(
                    store.state.auth.permissions,
                    allowedScope
                ) ||
                (allowGlobalPermission &&
                    verifyStrictPermission(
                        store.state.auth.globalPermissions,
                        allowedScope
                    ));
            return !!hasAccess;
        },
        hasGlobalPermission: function (allowedScope) {
            const hasAccess = verifyStrictPermission(
                store.state.auth.globalPermissions,
                allowedScope
            );
            return !!hasAccess;
        },

        verifyPagePermission: async function (
            allowedScope,
            redirectUrl,
            verifyMerchant = false,
            allowGlobalPermission = false
        ) {
            const hasAccess =
                verifyStrictPermission(
                    store.state.auth.permissions,
                    allowedScope
                ) ||
                (allowGlobalPermission &&
                    verifyStrictPermission(
                        store.state.auth.globalPermissions,
                        allowedScope
                    ));
            if (!hasAccess) {
                if ("$router" in this && "$swal" in this) {
                    await this.$swal.fire({
                        background: this.backgroundColor,
                        title: "No tienes permiso 💢",
                        text: `Permiso requerido ${allowedScope}`,
                        type: "warning",
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonText: "OK",
                        timer: 10000
                    });
                    this.$router.push(redirectUrl);
                } else {
                    alert("No tienes permiso 💢");
                    window.location.href = redirectUrl;
                }
                return false;
            }

            if (verifyMerchant && !this.selectedMerchant.merchantId) {
                await this.$swal.fire({
                    background: this.backgroundColor,
                    type: "info",
                    title: "Debes de seleccionar una tienda primero",
                    text: "Selecciona una tienda para continuar",
                    timer: 4000
                });
                store.commit("commons/REQUEST_MERCHANT_SELECTOR");
                return false;
            }
            return true;
        }
    };
};

export default abilityPluginImpl;
